import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IDataInput, IFeaturesConfig } from '../../../../interface/interfaces';

interface IInitialState {
    featuresLoading: boolean;
    featuresData: IFeaturesConfig[];
    featuresError: string;
}

const initialState: IInitialState = {
    featuresLoading: false,
    featuresData: [],
    featuresError: '',
};

const featuresSlice = createSlice({
    name: 'features',
    initialState,
    reducers: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        fetchFeaturesPending: (state: IInitialState, action: PayloadAction<IDataInput>) => {
            state.featuresLoading = true;
            state.featuresData = [];
        },

        fetchFeaturesFulfilled: (state: IInitialState, action: PayloadAction<IFeaturesConfig[]>) => {
            state.featuresLoading = false;
            state.featuresData = action.payload;
            state.featuresError = '';
        },

        fetchFeaturesFailure: (state: IInitialState, action: PayloadAction<string>) => {
            state.featuresLoading = false;
            state.featuresData = [];
            state.featuresError = action.payload;
        },
    },
});

export default featuresSlice.reducer;
export const { fetchFeaturesPending, fetchFeaturesFulfilled, fetchFeaturesFailure } = featuresSlice.actions;
